import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-filters" }
const _hoisted_2 = { class: "controls-row" }
const _hoisted_3 = { class: "search-section" }
const _hoisted_4 = { class: "icon-container" }
const _hoisted_5 = { class: "filters-section" }
const _hoisted_6 = { class: "icon-container" }
const _hoisted_7 = { class: "icon-container" }

import { Search, Plus, Lock } from '@element-plus/icons-vue';
import { useAuthStore } from '@/stores/auth';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchAndFilters',
  props: {
    search: {},
    difficulty: {},
    ingredientCount: {}
  },
  emits: ["update:search", "update:difficulty", "update:ingredientCount", "createRecipe"],
  setup(__props: any) {

const authStore = useAuthStore();





return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          "model-value": _ctx.search,
          placeholder: "Search recipes by title...",
          style: {"max-width":"350px"},
          clearable: "",
          size: "large",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:search', $event)))
        }, {
          prefix: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_unref(Search), { class: "button-icon" })
            ])
          ]),
          _: 1
        }, 8, ["model-value"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_select, {
          "model-value": _ctx.difficulty,
          placeholder: "Filter by difficulty",
          clearable: "",
          style: {"width":"180px"},
          size: "large",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:difficulty', $event)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "Easy",
              value: "EASY"
            }),
            _createVNode(_component_el_option, {
              label: "Medium",
              value: "MEDIUM"
            }),
            _createVNode(_component_el_option, {
              label: "Hard",
              value: "HARD"
            })
          ]),
          _: 1
        }, 8, ["model-value"]),
        _createVNode(_component_el_select, {
          "model-value": _ctx.ingredientCount,
          placeholder: "Ingredient count",
          clearable: "",
          style: {"width":"180px"},
          size: "large",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:ingredientCount', $event)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "1-5 ingredients",
              value: "1-5"
            }),
            _createVNode(_component_el_option, {
              label: "6-10 ingredients",
              value: "6-10"
            }),
            _createVNode(_component_el_option, {
              label: "11+ ingredients",
              value: "11+"
            })
          ]),
          _: 1
        }, 8, ["model-value"]),
        (_unref(authStore).isAuthenticated)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              class: "custom-button",
              size: "large",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('createRecipe')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_unref(Plus), { class: "button-icon" })
                ]),
                _cache[5] || (_cache[5] = _createTextVNode(" Create Recipe "))
              ]),
              _: 1,
              __: [5]
            }))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              class: "custom-button",
              size: "large",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/login')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_unref(Lock), { class: "button-icon" })
                ]),
                _cache[6] || (_cache[6] = _createTextVNode(" Login to Create "))
              ]),
              _: 1,
              __: [6]
            }))
      ])
    ])
  ]))
}
}

})